import React from "react";
import "../../static/css/dialog.scss";

export const DeviceDialog = () => {
  return (
    <div className="dialog">
      <div className="devide-dialog-container">
        <div className="devide-dialog-avator" />
        <div className="devide-dialog-title">
          请选择正确的
          <span className="devide-dialog-tips">扬声器</span>或
          <span className="devide-dialog-tips">耳机</span>
          ，确认设备已启用
        </div>
        <div className="devide-dialog-content">
          <div className="devide-dialog-content-issue" />
          <div className="devide-dialog-content-title">
            Windows系统；请逐一检查；
          </div>
          <ul className="devide-dialog-content-list">
            <li>进入系统“设备管理器”“声音，视频和游戏控制器”右键启用设备；</li>
            <li>右键点击扬声器图片打开</li>
            <li>任务栏右下角扬声器图标，确认非静音状态，调整至适合音量；</li>
            <li>右键点击扬声器图标打开</li>
          </ul>
        </div>
        <div className="devide-dialog-issue-statement">
          更详细说明请点击查看{" "}
          <span className="devide-dialog-issue-statement-tips">
            【常见问题说明】
          </span>
        </div>
        <div className="devide-dialog-button">
          <div
            className="devide-dialog-button-cancle"
            onClick={() => {
              window.history.back();
            }}
          >
            知道了
          </div>
          <div
            className="devide-dialog-button-sure"
            onClick={() => {
              window.history.back();
            }}
          >
            退出检测
          </div>
        </div>
      </div>
    </div>
  );
};

export const QRCodeDialog = ({ onClick }) => {
  return (
    <div className="dialog" onClick={e => onClick(e)}>
      <div className="QR-code-dialog-container">
        <div className="QR-code-dialog-avator" />
        <div className="QR-code-dialog-avator-book" />
        <div className="QR-code-dialog-info">
          宝贝还没开通学习内容哦～ 快让爸爸妈妈帮你联系预约吧！
          上完即有神秘礼物哦～！
        </div>
        <div className="QR-code-dialog-code" />
        <div className="QR-code-dialog-text">扫码加客服微信，开通学习内容授权</div>
      </div>
    </div>
  );
};

export const CommonDialog = ({
  title,
  text,
  otherText,
  otherHref,
  htmlText,
  htmlHanlder,
  cancleText,
  sureText,
  cancleHandler,
  sureHanlder,
  hasClose
}) => {
  return (
    <div className="dialog" style={{ background: "rgba(0, 0, 0, .5)" }}>
      <div className="common-dialog-container">
        <div className="common-dialog-avator" />
        <div className="common-dialog-title">{title}</div>
        <div className="common-dialog-text">{text}</div>
        {otherText && (
          <div className="common-dialog-text common-dialog-other-text">
            {otherHref ? (
              <span
                style={{ cursor: 'pointer' }}
                onClick={() => {
                  // window.open(otherHref)
                  window.location.href = otherHref;
                }}
              >
                {otherText}
              </span>
            ) : (
              otherText
            )}
          </div>
        )}
        {htmlText && (
          <div className="common-dialog-text" dangerouslySetInnerHTML={{ __html: htmlText }} onClick={() => {
            htmlHanlder && htmlHanlder();
          }} />
        )}
        {hasClose && (
          <div
            className="common-dialog-close"
            onClick={() => {
              cancleHandler && cancleHandler();
            }}
          />
        )}
        <div className="common-dialog-button">
          <div
            className="common-dialog-button-cancle"
            onClick={() => {
              cancleHandler && cancleHandler();
            }}
          >
            {cancleText ? cancleText : "取消"}
          </div>
          <div
            className="common-dialog-button-sure"
            onClick={() => {
              sureHanlder && sureHanlder();
            }}
          >
            {sureText ? sureText : "确定"}
          </div>
        </div>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/dialog/Dialog.js